import React, { useCallback } from 'react';
import BaseEventsPanel from 'containers/Pages/Events/Layouts/baseEventsPanel.jsx';
import { columns } from './columns';
import {
  BASE_INCIDENT_STATUS,
  EVENT_INCIDENT_STATUS,
} from 'utils/constants/eventStatus';
import { filters } from 'containers/Pages/Events/filters';
import EventDetails from './eventDetails';
import BaseEventsForm from './Layouts/baseEventForm';
import { useDispatch, useSelector } from 'react-redux';
import { modalState, toggleModal } from 'reducers/ui';
import { nameSpace } from './Modules/nameSpace';
import { getUserRoles } from 'reducers/users';
import { ManagerAndAbove, userHasRole } from 'utils/helper/roles';

const Events = () => {
  const userRoles = useSelector(state => getUserRoles(state));
  const defaultFilterValues = {
    incidentStatus: [...EVENT_INCIDENT_STATUS].filter(
      f => f.id !== BASE_INCIDENT_STATUS.COMPLETED_EVENT.key,
    ),
  };
  //-----------------------selectors-----------------------
  const eventModal = useSelector(state => modalState(state));
  //-----------------------Actions-------------------------
  const dispatch = useDispatch();

  const dispatchToggleModal = useCallback(
    () => dispatch(toggleModal(nameSpace)),
    [dispatch],
  );

  const loading = useSelector(state => state.ui.loading);
  return (
    <BaseEventsPanel
      columns={columns}
      defaultFilterValues={defaultFilterValues}
      filters={filters}
      filtersRequired={true}
      DetailComponent={EventDetails}
      FormComponent={BaseEventsForm}
      editable={true}
      toggleModal={dispatchToggleModal}
      onEdit={eventModal[nameSpace]}
      downloadable={userHasRole({
        userRoles: userRoles,
        requiredRoles: ManagerAndAbove,
      })}
      loading={loading}
    />
  );
};

export default Events;
